import api from '@/api/modules/authItems'
import {arrayToTree} from "@/utils/tree"

const state = () => ({
  // // 菜单列表
  // menu: [],
  // // 页面元素列表
  // pageEle: [],
  // 权限项列表
  authItems: [],
  isLoaded: false,
})
const getters = {
  menu: (state) => state.authItems.filter((item) => item.type === 'menu'),
  pageEle: (state) => state.authItems.filter((item) => item.type === 'pe'),
  home: (state) => {
    let home = state.authItems.find((item) => !!item.home)
    if (!home) {
      let menuList = state.authItems.filter((item) => item.type === 'menu' && !item.hidden)
      let tree = arrayToTree(menuList)
      if (tree && tree.length > 0) {
        home = tree[0]
        if (home.children && home.children > 0) {
          home = home.children[0]
        }
      }
    }
    if (!home) {
      home = {}
    }
    return home
  },
  authItems: (state) => state.authItems,
  isLoaded: (state) => state.isLoaded,
}
const mutations = {
  cleanAuthItems(state) {
    state.authItems = []
    state.isLoaded = false
  },
}
const actions = {
  async loadAuthItems({ commit, state }) {
    let { value } = await api.getMenuPEAuthItemsByLoggedUser()
    // if (!value || value.length === 0) {
    //   value = [
    //     {
    //       name: '未授权',
    //       url: '/unauthorized',
    //       code: 'unauthorized',
    //       component: 'unauthorized.vue',
    //       type: 'menu',
    //       parentId: '0'
    //     }
    //   ]
    // }
    // state.authItems = value
    // state.isLoaded = true

    let result = [];
    result.push({
      name: '基础信息',
      id:1,
      parentId:'0',
      url: `/baseInfo/venueTypeSetting`,
      code: `appList`,
      component: '/baseInfo/venueTypeSetting/index',
      type: 'menu',
    });
    state.authItems = result
    state.isLoaded = true
  },
  cleanAuthItems({ commit }) {
    commit('cleanAuthItems')
  },
}
export default { state, getters, mutations, actions }
